import { render, staticRenderFns } from "./productfProcess.vue?vue&type=template&id=b7736c30&scoped=true"
import script from "./productfProcess.vue?vue&type=script&lang=js"
export * from "./productfProcess.vue?vue&type=script&lang=js"
import style0 from "./productfProcess.vue?vue&type=style&index=0&id=b7736c30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7736c30",
  null
  
)

export default component.exports